import { defineComponent as C, ref as b, computed as t } from "vue";
import O from "./td-longtail-vue-components5.js";
import U from "./td-longtail-vue-components259.js";
import q from "./td-longtail-vue-components14.js";
import { registerConsent as x, isSocialConsentGiven as B } from "./td-longtail-vue-components88.js";
const L = /* @__PURE__ */ C({
  __name: "youtube-video",
  props: {
    videoId: {
      type: String,
      required: !0
    },
    description: {
      type: String,
      default: ""
    },
    duration: {
      type: String,
      default: ""
    },
    uploadDate: {
      type: String,
      default: ""
    },
    border: {
      type: Boolean
    },
    overlayOpacity: { type: Number, default: 1 }
  },
  emits: ["open"],
  setup(g, { expose: w, emit: d }) {
    const e = g, S = b("* Videoinhalte werden von Youtube abgerufen"), p = b(!1), i = t(() => `https://www.youtube-nocookie.com/embed/${e.videoId}`), l = t(() => `${i.value}?autoplay=1&rel=0`), a = t(() => `https://i.ytimg.com/vi_webp/${e.videoId}/hqdefault.webp`), u = t(() => `https://i.ytimg.com/vi_webp/${e.videoId}/sddefault.webp`), s = t(() => `https://i.ytimg.com/vi_webp/${e.videoId}/maxresdefault.webp`), h = t(() => `
        ${a.value} 480w,
        ${u.value} 640w,
        ${s.value} 1280w
      `.trim()), c = t(() => `https://youtube.googleapis.com/v/${e.videoId}`), o = t(() => {
      if (e.duration)
        return parseInt(e.duration.split(":")[0], 10);
    }), r = t(() => {
      if (e.duration)
        return parseInt(e.duration.split(":")[1], 10);
    }), m = t(() => {
      if (!(!o.value || !r.value))
        return `PT${o.value}M${r.value}S`;
    }), v = t(() => {
      if (!(!o.value || !r.value))
        return o.value * 60 + r.value;
    }), $ = t(() => e.description), f = t(() => {
      if (!e.uploadDate)
        return;
      const [n, _, D] = e.uploadDate.split(".").map((P) => parseInt(P, 10));
      return new Date(D, _ - 1, n + 1).toJSON();
    }), I = t(() => {
      const n = [];
      return e.border && n.push("youtube-video--bordered"), n;
    });
    x();
    const y = () => {
      p.value = !0, d("open");
    };
    return w({
      open: y,
      autoplayUrl: l,
      url: i,
      imgSrc: a,
      imgSrcSm: u,
      jsonUploadDate: f,
      imgSrcMd: s,
      embedUrl: c,
      minutes: o,
      seconds: r,
      totalSeconds: v,
      iso8601duration: m
    }), { __sfc: !0, props: e, emits: d, youtubeDisclaimer: S, isOpened: p, url: i, autoplayUrl: l, imgSrc: a, imgSrcSm: u, imgSrcMd: s, srcset: h, embedUrl: c, minutes: o, seconds: r, iso8601duration: m, totalSeconds: v, hasItemprops: $, jsonUploadDate: f, classes: I, open: y, Paragraph: O, GdprPermissionLayer: U, PlayPauseButton: q, isSocialConsentGiven: B };
  }
});
export {
  L as default
};
